<footer class="fixed bottom-0 left-0 right-0 z-50 block md:hidden transition-transform duration-300 ease-in-out" 
        [class.translate-y-0]="!isScrollingDown" 
        [class.translate-y-full]="isScrollingDown">
  <nav class="relative bg-black/25 backdrop-blur-lg shadow-neumorphic-dark rounded-t-2xl border-t-2 border-white/5">
    <!-- 🌌 Fondo animado galáctico detrás -->
    <div class="absolute inset-0 bg-amethyst-dark opacity-90 -z-10 rounded-t-2xl"></div>

    <ul class="flex justify-around items-center h-20 text-gray-400">
      <li>
        <a routerLink="/" 
           routerLinkActive="nav-link-button-active" 
           [routerLinkActiveOptions]="{exact: true}" 
           appGalaxyRipple
           class="relative flex flex-col items-center justify-center w-20 h-16 rounded-2xl overflow-hidden transition-all duration-150 ease-in-out shadow-neumorphic-dark text-gray-400 font-medium hover:bg-white/10 hover:text-white active:scale-95 active:shadow-neumorphic-dark-inset">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/></svg>
          <span class="text-xs mt-1">Inicio</span>
        </a>
      </li>
      <li>
        <a routerLink="/tienda" 
           routerLinkActive="nav-link-button-active" 
           appGalaxyRipple
           class="relative flex flex-col items-center justify-center w-20 h-16 rounded-2xl overflow-hidden transition-all duration-150 ease-in-out shadow-neumorphic-dark text-gray-400 font-medium hover:bg-white/10 hover:text-white active:scale-95 active:shadow-neumorphic-dark-inset">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" /></svg>
          <span class="text-xs mt-1">Tienda</span>
        </a>
      </li>
      <li>
        <a routerLink="/cart/sumary" 
           routerLinkActive="nav-link-button-active" 
           appGalaxyRipple
           class="relative flex flex-col items-center justify-center w-20 h-16 rounded-2xl overflow-hidden transition-all duration-150 ease-in-out shadow-neumorphic-dark text-gray-400 font-medium hover:bg-white/10 hover:text-white active:scale-95 active:shadow-neumorphic-dark-inset">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
          <span class="text-xs mt-1">Carrito</span>
        </a>
      </li>
      <li>
        <a routerLink="/order-history" 
           routerLinkActive="nav-link-button-active" 
           appGalaxyRipple
           class="relative flex flex-col items-center justify-center w-20 h-16 rounded-2xl overflow-hidden transition-all duration-150 ease-in-out shadow-neumorphic-dark text-gray-400 font-medium hover:bg-white/10 hover:text-white active:scale-95 active:shadow-neumorphic-dark-inset">
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
          <span class="text-xs mt-1">Órdenes</span>
        </a>
      </li>

    </ul>
  </nav>
</footer>
